import React, { useState } from 'react';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useApiQuery } from '../../hooks/useApiQuery';
import { list as listCategories } from '../../apis/categories';
import { list as listProducts } from '../../apis/products';
import { list as listOrders } from '../../apis/orders';
import { list as listUsers } from '../../apis/users';

import { AdminBreadcrumb } from '../../components/admin/AdminBreadcrumb';
import { DashboardCard } from '../../components/admin/DashboardCard';

export const AdminDashboardPage = () => {
    useDocumentTitle('Dashboard');

    const [options] = useState({ page: 1, size: 1, mode: 'admin' });
    const categories = useApiQuery(listCategories, options);
    const products = useApiQuery(listProducts, options);
    const users = useApiQuery(listUsers, options);
    const orders = useApiQuery(listOrders, options);

    return (
        <div className="dashboard-page mb-5">
            <h1 className="h3">Dashboard</h1>
            <AdminBreadcrumb />
            <div className="row">
                <div className="col-xl-3">
                    <DashboardCard
                        title="Categories"
                        icon="shapes"
                        to="/admin/categories"
                        isLoading={categories.isLoading}
                        quantity={categories.hasData ? categories.data.total : 0}
                    />
                </div>
                <div className="col-xl-3">
                    <DashboardCard
                        title="Products"
                        icon="icons"
                        to="/admin/products"
                        isLoading={products.isLoading}
                        quantity={products.hasData ? products.data.total : 0}
                    />
                </div>
                <div className="col-xl-3">
                    <DashboardCard
                        title="Users"
                        icon="users"
                        to="/admin/users"
                        isLoading={users.isLoading}
                        quantity={users.hasData ? users.data.total : 0}
                    />
                </div>
                <div className="col-xl-3">
                    <DashboardCard
                        title="Orders"
                        icon="file-invoice"
                        to="/admin/orders"
                        isLoading={orders.isLoading}
                        quantity={orders.hasData ? orders.data.total : 0}
                    />
                </div>
            </div>
        </div>
    );
};
